import { useState, useEffect } from "react";
import { loadShifRosterEmployeeListByDepartmentID } from "../services/shiftService";



const useShiftRoasterEmployeeListByDepartment = (editShiftAssignmentID, selectedDepartmentID) => {
    const [employeeList, setEmployeeList] = useState([]);
    const [isShiftRoasterDataLoaded, setIsShiftRoasterDataLoaded] = useState(false);

    // Fetch department data
    const fetchShiftRoaster = async (selectedID = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_department: selectedDepartmentID
        };

        try {
            //loadShifRosterEmployeeListByDepartmentID
            const data = await loadShifRosterEmployeeListByDepartmentID(para);
            if (data && data.length > 0) {
                setEmployeeList(data);                
            }
            else{
                setEmployeeList([]);   
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    const fetchSelectedShiftRoaster = async (selectedID = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_department: selectedID
        };

        try {
            //loadShifRosterEmployeeListByDepartmentID
            const data = await loadShifRosterEmployeeListByDepartmentID(para);
            if (data && data.length > 0) {
                setEmployeeList(data);                
            }
            else{
                setEmployeeList([]);   
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isShiftRoasterDataLoaded && editShiftAssignmentID === 0) {
            fetchShiftRoaster();
        }
    }, [isShiftRoasterDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID 

    const loadEmployeeListShiftRosterByDepartmentID = async (selectedID) => {
        await fetchSelectedShiftRoaster(selectedID);
    };



    return {
        employeeList,      
        loadEmployeeListShiftRosterByDepartmentID,
    };
};

export default useShiftRoasterEmployeeListByDepartment;